import {Grid} from '@logistics-frontend/blocks'
import {PhoneInput} from '@logistics-frontend/blocks/lpc/input'
import {PhoneMask} from '@logistics-frontend/core/formatters'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useAddress, useAddressContactPhone, useRequirements, useTariff} from '@yandex-taxi/react-integration-api'
import React, {useEffect} from 'react'

import {useConfig} from 'src/config'

import {CLASS_FOR_SCROLL_TO_ERROR} from '../../../../consts'
import {Props} from '../../../../shared/address'
import {useAddressGoalCallback} from '../../../../shared/metrika'
import {Tariff} from '../../../consts'
import Comment from './Comment'
import HomeAddress from './HomeAddress'

const int18Masks: PhoneMask = {
  '7': '+# (###) ###-##-##',
  '998': '+###-##-###-####',
  '375': '+### (##) ###-##-##',
}

const localMasks: PhoneMask = {
  '8': '# (###) ###-##-##',
}

const ExtraData: React.FC<Props> = ({index, length}) => {
  const t = useI18n()
  const [{value: requirements}] = useRequirements()
  const [{value: tariff}] = useTariff()
  const [{value: address}] = useAddress(index)
  const shouldShowHomeAddress = (requirements?.door_to_door === true || tariff === Tariff.CARGO) && address
  const shouldShowPhone = index === 0 || tariff !== Tariff.CARGO
  const [{value: contactPhone = '', touched, error}, {setValue, setTouched}] = useAddressContactPhone(index)
  const goalCallback = useAddressGoalCallback(index, length)
  const config = useConfig()

  const errorText: string | undefined = touched && error ? error : undefined
  const placeholder =
    index === 0
      ? t('order.form.address.source_number', 'Номер отправителя')
      : t('order.form.address.recipient_number', 'Номер получателя')

  useEffect(() => {
    if (!shouldShowPhone) {
      setValue('')
    }
  }, [setValue, shouldShowPhone])

  return (
    <>
      {shouldShowHomeAddress && <HomeAddress index={index} length={length} />}
      {shouldShowPhone && (
        <Grid md={6} xs={12} item>
          <PhoneInput
            className={errorText ? CLASS_FOR_SCROLL_TO_ERROR : null}
            error={!!errorText}
            helperText={errorText}
            inputProps={{
              autoComplete: `section-${index} tel`,
            }}
            int18Masks={int18Masks}
            localMasks={localMasks}
            onBlur={() => {
              setTouched()
              goalCallback('Phone')
            }}
            onChange={event => setValue(event.target.value)}
            onFocus={() => setTouched(false)}
            phoneCode={config.phoneCode}
            placeholder={placeholder}
            value={contactPhone}
            fullWidth
          />
        </Grid>
      )}
      <Grid item xs>
        <Comment index={index} length={length} />
      </Grid>
    </>
  )
}

export default ExtraData
